// SendEmailMessageSection.jsx

import React from 'react';

// Components
import ModalField from 'components/modal/field/ModalField';
import ModalLabel from 'components/modal/label/ModalLabel';
import TextInput from 'components/textinput/TextInput';

/**
 * SendEmailMessageSection
 *
 * Renders the free-text message editor for send-email actions.
 *
 * @param {string} messageText - Current message text value.
 * @param {function} onMessageChange - Updates message text.
 *
 * @returns {ReactNode} The rendered message editor section.
 */
const SendEmailMessageSection = React.memo(({ messageText, onMessageChange }) => {

  // ----- RENDER ----- //

  return (
    <ModalField>
      <ModalLabel label="Message" />
      <TextInput
        multiline
        expandable
        placeholder="Message shown at the top of the email..."
        type="text"
        value={messageText}
        onChange={(event) => onMessageChange(event.target.value)}
      />
    </ModalField>
  );
});

// Dev Tools
SendEmailMessageSection.displayName = 'SendEmailMessageSection';

export default SendEmailMessageSection;
